module.exports = __webpack_public_path__ + "img/csgo.e49ab771.svg";